export default function (storico) {
  this.id = storico ? storico.id : null;
  this.Anno = storico ? storico.Anno : null;
  this.AssociatoId = storico ? storico.AssociatoId : null;
  this.NumeroTessera = storico ? storico.NumeroTessera : null;
  this.Denominazione = storico ? storico.Denominazione : null;
  this.CodiceFiscale = storico ? storico.CodiceFiscale : null;
  this.Sesso = storico ? storico.Sesso : null;
  this.Email = storico ? storico.Email : null;
  this.AssociazioneId = storico ? storico.AssociazioneId : null;
  this.AssociazioneDenominazione = storico ? storico.AssociazioneDenominazione : null;
  this.StatoIscrizione = storico ? storico.StatoIscrizione : null;
  this.StatoAnagrafica = storico ? storico.StatoAnagrafica : null;
  this.DataRichiesta = storico ? storico.DataRichiesta : null;
  this.DataConferma = storico ? storico.DataConferma : null;
  this.DataAnnullamento = storico ? storico.DataAnnullamento : null;
  this.TipoTessera = storico ? storico.TipoTessera : null;
  this.TesseraCsain = storico ? storico.TesseraCsain : null;
  this.Agonista = storico ? storico.Agonista : null;
  this.TutelaSanitaria = storico ? storico.TutelaSanitaria : null;
  this.Open = storico ? storico.Open : null;
}
